module.exports = __webpack_public_path__ + "img/mechanical-arm.09b0a5f1.svg";